import React from "react";
import { Container, Heading } from "@chakra-ui/react";
import CardForm from "../../components/CardForm";
import { useAppSelector } from "../../redux/store";

const Dashboard: React.FC = () => {
  const { me } = useAppSelector((state) => state.auth);

  return (
    <Container maxW="container.xl">
      <CardForm>
        <Heading as="h3" fontSize="2xl">
          Welcome, {me?.name}
        </Heading>
      </CardForm>
    </Container>
  );
};

export default Dashboard;
